(() => {
  const GIFT_VARIANT_ID = 55336997585160;

  let isUpdating = false;
  let isInternalUpdate = false;
  let syncTimeout = null;

  function getRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  async function getCart() {
    const res = await fetch(`${getRoot()}cart.js`, {
      credentials: 'same-origin',
      cache: 'no-store'
    });
    return res.json();
  }

  function hasGift(cart) {
    return cart.items.some((item) => item.variant_id === GIFT_VARIANT_ID);
  }

  function hasRealProducts(cart) {
    return cart.items.some((item) => item.variant_id !== GIFT_VARIANT_ID);
  }

  function getGiftLine(cart) {
    const index = cart.items.findIndex((item) => item.variant_id === GIFT_VARIANT_ID);
    return index === -1 ? null : index + 1;
  }

  function isCartPage() {
    return !!document.querySelector('cart-items');
  }

  function isCartDrawerPresent() {
    return !!document.querySelector('cart-drawer');
  }

  async function fetchSections(sectionIds, sectionsUrl = window.location.pathname) {
    const params = new URLSearchParams();
    params.set('sections', sectionIds.join(','));
    params.set('sections_url', sectionsUrl);

    const res = await fetch(`${getRoot()}?${params.toString()}`, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    return res.json();
  }

  function replaceSection(containerSelector, sectionHtml) {
    if (!sectionHtml) return;

    const target = document.querySelector(containerSelector);
    if (!target) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHtml, 'text/html');

    let newContent = null;

    const exactMatch = doc.querySelector(containerSelector);
    if (exactMatch) {
      newContent = exactMatch.innerHTML;
    } else {
      const jsContents = doc.querySelector('.js-contents');
      if (jsContents) {
        newContent = jsContents.innerHTML;
      } else {
        newContent = doc.body.innerHTML;
      }
    }

    if (newContent !== null) {
      target.innerHTML = newContent;
    }
  }

  function replaceCartItemsSection(sectionHtml) {
    if (!sectionHtml) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHtml, 'text/html');

    const newCartItems = doc.querySelector('cart-items');
    const currentCartItems = document.querySelector('cart-items');

    if (newCartItems && currentCartItems) {
      currentCartItems.replaceWith(newCartItems);
    }
  }

  function showGiftMessage() {
  const msg = document.getElementById('gift-notification-message');
  if (!msg) return;

  msg.style.display = 'block';

  // 🔥 forzar reflow para que la animación funcione SIEMPRE
  msg.offsetHeight;

  msg.classList.add('is-visible');
}

  function hideGiftMessage() {
  const msg = document.getElementById('gift-notification-message');
  if (!msg) return;

  msg.classList.remove('is-visible');

  setTimeout(() => {
    msg.style.display = 'none';
  }, 300); // igual que el transition
}

  async function refreshCartUI() {
    try {
      if (isCartPage()) {
        const data = await fetchSections(
          ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'],
          '/cart'
        );

        replaceCartItemsSection(data['main-cart-items']);
        replaceSection('#main-cart-footer', data['main-cart-footer']);
        replaceSection('#cart-icon-bubble', data['cart-icon-bubble']);
      }

      if (isCartDrawerPresent()) {
        const data = await fetchSections(
          ['cart-drawer', 'cart-icon-bubble'],
          '/cart'
        );

        const drawer = document.querySelector('cart-drawer');
        if (drawer && data['cart-drawer']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
          const newDrawer = doc.querySelector('cart-drawer');

          if (newDrawer) {
            drawer.innerHTML = newDrawer.innerHTML;
          }
        }

        replaceSection('#cart-icon-bubble', data['cart-icon-bubble']);
      }

      document.dispatchEvent(new Event('cart:refresh'));
    } catch (e) {
      console.error('Error refreshing cart UI:', e);
    }
  }

  async function addGift() {
    if (isUpdating) return;
    isUpdating = true;
    isInternalUpdate = true;

    try {
      const res = await fetch(`${getRoot()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: GIFT_VARIANT_ID, quantity: 1 }]
        })
      });

      if (!res.ok) {
        const txt = await res.text().catch(() => '');
        console.error('Error adding gift:', res.status, txt);
      }

      await refreshCartUI();
      showGiftMessage();
    } catch (e) {
      console.error('Error adding gift:', e);
    } finally {
      isInternalUpdate = false;
      isUpdating = false;
    }
  }

  async function removeGift() {
    if (isUpdating) return;
    isUpdating = true;
    isInternalUpdate = true;

    try {
      const cart = await getCart();
      const giftLine = getGiftLine(cart);

      if (!giftLine) {
        await refreshCartUI();
        hideGiftMessage();
        return;
      }

      const res = await fetch(`${getRoot()}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: giftLine,
          quantity: 0
        })
      });

      if (!res.ok) {
        const txt = await res.text().catch(() => '');
        console.error('Error removing gift:', res.status, txt);
      }

      await refreshCartUI();
      hideGiftMessage();
    } catch (e) {
      console.error('Error removing gift:', e);
    } finally {
      isInternalUpdate = false;
      isUpdating = false;
    }
  }

  async function syncGift() {
    if (isUpdating) return;

    try {
      const cart = await getCart();
      const giftInCart = hasGift(cart);
      const hasProducts = hasRealProducts(cart);

      if (hasProducts && !giftInCart) {
        await addGift();
        return;
      }

      if (!hasProducts && giftInCart) {
        await removeGift();
        return;
      }
    } catch (e) {
      console.error('Error syncing gift:', e);
    }
  }

  function scheduleSync(delay = 350) {
    clearTimeout(syncTimeout);
    syncTimeout = setTimeout(syncGift, delay);
  }

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

      if (isInternalUpdate) return response;

      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      ) {
        scheduleSync(450);
      }
    } catch (e) {
      console.error('Fetch intercept error:', e);
    }

    return response;
  };

  document.addEventListener('click', (e) => {
    const target = e.target;
    if (!target) return;

    if (
      target.closest('.cart-remove-button') ||
      target.closest('cart-remove-button') ||
      target.closest('[name="minus"]') ||
      target.closest('[name="plus"]')
    ) {
      scheduleSync(500);
    }
  });

  document.addEventListener('change', (e) => {
    const target = e.target;
    if (target.matches('.quantity__input, input[name="updates[]"]')) {
      scheduleSync(500);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    hideGiftMessage();
    scheduleSync(600);
  });

  window.addEventListener('pageshow', () => {
    scheduleSync(300);
  });
})();